module.exports = __webpack_public_path__ + "static/img/byakika.43824ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/byakika.jpg
// module id = 57
// module chunks = 1